/**
 * Map of backend error codes to user-friendly messages in Spanish.
 * When the API returns an errorCode, the client looks up the message here
 * and shows it as a toast automatically.
 */
export const ERROR_MESSAGES: Record<string, string> = {
  // Auth
  AUTH_INVALID_CREDENTIALS: 'Credenciales invalidas',
  AUTH_REFRESH_TOKEN_EXPIRED: 'La sesion ha expirado, inicie sesion nuevamente',
  AUTH_USER_NOT_FOUND: 'Usuario no encontrado',

  // Company / Proveedor
  COMPANY_RUC_EXISTS: 'El RUC ya esta registrado en el sistema',
  COMPANY_NOT_FOUND: 'Empresa no encontrada',
  COMPANY_BUSINESS_NOT_FOUND: 'Registro de negocio no encontrado',
  PROVEEDOR_NOT_FOUND: 'El minero no fue encontrado',
  MINING_SUPPLIER_NOT_FOUND: 'Los datos del minero no fueron encontrados',

  // Permissions
  PERMISSION_DENIED: 'Permisos insuficientes para realizar esta accion',
  ACTIVE_ROLE_NOT_FOUND: 'No tienes un rol activo asignado',
  ACTIVE_ROLE_NOT_ASSIGNED: 'El rol seleccionado ya no esta disponible',

  // Validation
  VALIDATION_ERROR: 'Error de validacion',

  // General
  NETWORK_ERROR: 'Error de conexion con el servidor',
  UNKNOWN_ERROR: 'Ha ocurrido un error inesperado',
}

/**
 * Get the user-friendly message for an error code.
 * Falls back to the raw error message if no mapping exists.
 */
export function getErrorMessage(errorCode: string | null, fallback: string): string {
  if (errorCode && ERROR_MESSAGES[errorCode]) {
    return ERROR_MESSAGES[errorCode]
  }
  return fallback
}
